import React from 'react';
import { GamificationStats } from '../types';

interface UserTagsCardProps {
  gamificationStats: GamificationStats | null;
  isMobile?: boolean;
}

export const UserTagsCard: React.FC<UserTagsCardProps> = ({
  gamificationStats,
  isMobile = false
}) => {
  // Combinar todos los tags (comunes y personalizados) sin duplicados
  const allTags: Array<{tag: string, count: number, isPositive: boolean, isCustom: boolean}> = [];
  const tagMap = new Map<string, {tag: string, count: number, isPositive: boolean, isCustom: boolean}>();
  
  // Agregar tags positivos comunes
  if (gamificationStats?.topPositiveTags) {
    gamificationStats.topPositiveTags.forEach(tag => {
      const key = `${tag.tag}-pos`;
      if (!tagMap.has(key) || tagMap.get(key)!.count < tag.count) {
        tagMap.set(key, {...tag, isPositive: true, isCustom: false});
      }
    });
  }
  
  // Agregar tags negativos comunes
  if (gamificationStats?.topNegativeTags) {
    gamificationStats.topNegativeTags.forEach(tag => {
      const key = `${tag.tag}-neg`;
      if (!tagMap.has(key) || tagMap.get(key)!.count < tag.count) {
        tagMap.set(key, {...tag, isPositive: false, isCustom: false});
      }
    });
  }
  
  // Agregar tags positivos personalizados
  if (gamificationStats?.topCustomPositiveTags) {
    gamificationStats.topCustomPositiveTags.forEach(tag => {
      const key = `${tag.tag}-pos`;
      if (!tagMap.has(key) || tagMap.get(key)!.count < tag.count) {
        tagMap.set(key, {...tag, isPositive: true, isCustom: true});
      }
    });
  }
  
  // Agregar tags negativos personalizados
  if (gamificationStats?.topCustomNegativeTags) {
    gamificationStats.topCustomNegativeTags.forEach(tag => {
      const key = `${tag.tag}-neg`;
      if (!tagMap.has(key) || tagMap.get(key)!.count < tag.count) {
        tagMap.set(key, {...tag, isPositive: false, isCustom: true});
      }
    });
  }
  
  // Convertir Map a Array y ordenar por cantidad (mayor a menor)
  const sortedTags = Array.from(tagMap.values())
    .sort((a, b) => b.count - a.count)
    .slice(0, 6);

  return (
    <div style={{
      backgroundColor: '#23272A',
      padding: isMobile ? '10px' : '24px',
      borderRadius: '18px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      border: '1px solid #33383B',
      flex: isMobile ? 'none' : '1',
      minHeight: isMobile ? 'auto' : '300px',
      position: 'relative'
    }}>
      <h3 style={{ 
        fontSize: isMobile ? '16px' : '18px', 
        fontWeight: 'bold', 
        margin: '0 0 16px 0',
        color: '#00E676',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px'
      }}>
        🏆 Tags Más Recibidos
      </h3>
      
      {sortedTags.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '10px' : '12px' }}>
          {sortedTags.map((tag, index) => (
            <div key={`${tag.isCustom ? 'custom-' : ''}${tag.isPositive ? 'pos' : 'neg'}-${tag.tag}`} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: isMobile ? '8px 0' : '10px 0'
            }}>
              {/* Tag con el estilo especificado */}
              <span style={{
                backgroundColor: tag.isPositive ? 'rgb(0, 230, 118)' : 'rgb(211, 47, 47)',
                color: tag.isPositive ? 'rgb(24, 26, 27)' : 'rgb(255, 255, 255)',
                padding: isMobile ? '4px 8px' : '6px 12px',
                borderRadius: '6px',
                fontSize: isMobile ? '12px' : '14px',
                fontWeight: 'bold',
                border: tag.isPositive ? 'none' : '1px solid rgb(255, 255, 255)'
              }}>
                {tag.tag}
              </span>
              
              {/* Número de conteo */}
              <div style={{
                fontSize: isMobile ? '12px' : '13px',
                fontWeight: 'bold',
                color: '#FFFFFF',
                backgroundColor: '#2C2F33',
                borderRadius: '50%',
                width: isMobile ? '20px' : '24px',
                height: isMobile ? '20px' : '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {tag.count}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '40px', color: '#B0BEC5' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🏆</div>
          <div style={{ fontSize: '16px', marginBottom: '8px', fontWeight: 'bold', color: '#FFFFFF' }}>
            Todavía no recibiste ningún Tag
          </div>
          <div style={{ fontSize: '14px', lineHeight: '1.4' }}>
            ¡Jugá un partido para poder recibir uno!
          </div>
        </div>
      )}
    </div>
  );
};